export let baseUrl;
export let transformationsPreset;
export let defaultPlaceholder;
export let onErrorPlaceholder;
export let noImagePlaceholder;
export function initDirectusImages(context) {
    if (!context.baseUrl) {
        throw new Error('baseUrl is required');
    }
    baseUrl = context.baseUrl;
    transformationsPreset = context.transformationsPreset;
    defaultPlaceholder = context.defaultPlaceholder;
    onErrorPlaceholder = context.onErrorPlaceholder || context.noImagePlaceholder || defaultPlaceholder;
    noImagePlaceholder = context.noImagePlaceholder || context.onErrorPlaceholder || defaultPlaceholder;
}
